import axios from "axios";
import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import ReactToPrint from "react-to-print";
import Listprint from "../../Listprint";
import AuthorForm from "./AuthorForm";

class   Author extends Component{

    state = {
        isModal : false,
        formData : null,
        time_end : null,
        authors : [],
    }

    componentDidMount(){
        this.getauthors();
    }

    handleInputM = (e) => {
        this.getauthors();
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async getauthors(){
        this.setState({ authors : [] })
        var authors = await axios.get('authors');
        if(authors.status === 200)
        {
            this.setState({authors : authors.data}) 
        }
    }

    showModal = (author = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : author,
        })
        this.getauthors();
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    delete = (author) =>{
        axios.delete("authors/" + author).then((response) => {
            this.getauthors()
        }).catch((error)=>{})
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        var rows = [], columns = [
            {
                label: 'Nom',
                field: 'last_name',
                sort: 'asc',
                width: 50
            },
            {
                label: 'prenom',
                field: 'first_name',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Nationalité',
                field: 'nationality',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Livre',
                field: 'countbook',
                sort: 'asc',
                width: 50
            },
            {
                label: '#',
                field: 'action',
                sort: 'asc',
                width: 50,
                class: 'table_action'
            },
        ];
        this.state.authors.map((author) => {
            
            rows.push({
                last_name : author.last_name,
                first_name : author.first_name,
                nationality : author.nationality,
                countbook : author.authorbooks.length,
                action : <span className="table_action">
                        {
                            this.handleCheck("Modifier auteur") == true && (
                                <div className="widget-todo-item-action d-flex align-items-center">
                                    <FeatherIcon icon="edit-2" size="16" className='cursor-move text-primary' type="button" onClick={() => this.showModal(author)}></FeatherIcon>
                                </div>
                            )
                        }
                </span>
            })
        })
        return(
            <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Les auteurs des livres</h5>
                {
                    this.handleCheck("Ajouter auteur") == true && (
                        <div className="btn-toolbar mb-2 mb-md-0">
                            <div className="btn-group me-2">
                                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(null)}><FeatherIcon icon="plus-circle" ></FeatherIcon></button>
                            </div>
                        </div>
                    )
                }
            </div>
            

            <div className="card shadow mb-2">
                <div className="card-body">
                    <div className="row overflow-auto mt-2">
                        {
                            rows.length > 0 && (
                                <Listprint columns={columns} rows={rows} title={"Les differents auteurs"}/>
                            )
                        }
                    </div>
                </div>
            </div>

            <AuthorForm
                isModal={this.state.isModal} 
                formData={this.state.formData} 
                showModal={this.showModal}
            />

        </div>
        )
    }
}
export default Author;
